import React, { useRef } from 'react';
import { styled } from '@compiled/react';
import { useAnalyticsEvents, type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { DropdownItem, type DropdownItemProps } from '@atlaskit/dropdown-menu';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

type RouteLinkItemProps = DropdownItemProps & {
	className?: string;
	name?: string;
	role?: string;
	id?: string;
	rel?: string;
	styleClass?: string;
	menuItemId: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onClick: (event: any) => void;
};
export const DropdownItemLink = ({
	styleClass,
	onClick,
	name,
	children,
	href,
	menuItemId,
}: RouteLinkItemProps) => {
	const webItemLinkRef = useRef<HTMLAnchorElement>(null);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent: UIAnalyticsEvent = createAnalyticsEvent({
		action: 'clicked',
	});
	const onClickWebItem = (e: React.MouseEvent | React.KeyboardEvent) => {
		if (webItemLinkRef.current?.classList.contains('ap-dialog')) {
			e.preventDefault();
			webItemLinkRef.current?.click();

			fireUIAnalytics(analyticsEvent, 'dropdownItem clicked', 'meatballMenu', {
				dropdownItem: menuItemId,
			});

			return;
		}

		onClick(e);
	};
	return (
		<>
			<DropdownItem onClick={onClickWebItem} href={href} target="_blank">
				{children}
			</DropdownItem>

			{/**
			 * Connect add-ons work by a "DOM is source of truth" approach.
			 * This is a very outdated style. Class name on this element
			 * will be used by another script to attach event listeners and
			 * open this plug-in into a modal.
			 */}
			{styleClass && (
				<HiddenLink
					ref={webItemLinkRef}
					href={href}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styleClass}
				>
					{name}
				</HiddenLink>
			)}
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HiddenLink = styled.a({
	display: 'none',
});
